var $ = require("jquery");
window.jQuery = $;
require("@fancyapps/fancybox");

(function ($, window) {

    $(function () {

        $(".video-button").on('click', function () {
            let video_url = $(this).data('video-url');
            $.fancybox.open($({
                src: video_url,
                'transitionIn': 'elastic',
                'transitionOut': 'elastic',
                'speedIn': 400,
                'speedOut': 200,
                'overlayShow': false,
                youtube: {
                    controls: 1,
                    showinfo: 1
                },
            }));
        });
        const productImages = $('.product-detail__gallery-img');

        if (productImages.length) {
            productImages.on('click', function () {
                productImages.removeClass('first').css('order', 2);
                $(this).addClass('first').css('order', 1);
            });

            productImages.find('a').fancybox({
                loop: true,
                buttons: [
                    "zoom",
                    "slideShow",
                    "thumbs",
                    "close"
                ]
            });
        }
    });
})(jQuery, window);
